import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

const ScheduleDateRangeInput = ({
    startsOn = '',
    endsOn = '',
    onStartsOnChange,
    onEndsOnChange,
    disabled = false,
    startsOnLabel = 'Starts on',
    endsOnLabel = 'Ends on (optional)',
}) => (
    <Box sx={{ display: 'flex', gap: 2 }}>
        <TextField
            fullWidth
            type="date"
            label={startsOnLabel}
            value={startsOn}
            disabled={disabled}
            InputLabelProps={{ shrink: true }}
            sx={{ flex: 1 }}
            onChange={(e) => {
                if (onStartsOnChange) {
                    onStartsOnChange(e.target.value);
                }
            }}
        />
        <TextField
            fullWidth
            type="date"
            label={endsOnLabel}
            value={endsOn}
            disabled={disabled}
            InputLabelProps={{ shrink: true }}
            sx={{ flex: 1 }}
            onChange={(e) => {
                if (onEndsOnChange) {
                    onEndsOnChange(e.target.value);
                }
            }}
        />
    </Box>
);

ScheduleDateRangeInput.propTypes = {
    startsOn: PropTypes.string,
    endsOn: PropTypes.string,
    onStartsOnChange: PropTypes.func,
    onEndsOnChange: PropTypes.func,
    disabled: PropTypes.bool,
    startsOnLabel: PropTypes.string,
    endsOnLabel: PropTypes.string,
};

ScheduleDateRangeInput.defaultProps = {
    startsOn: '',
    endsOn: '',
    onStartsOnChange: undefined,
    onEndsOnChange: undefined,
    disabled: false,
    startsOnLabel: 'Starts on',
    endsOnLabel: 'Ends on (optional)',
};

export default ScheduleDateRangeInput;

